import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import {
  Button,
  Form,
  Grid,
  Header,
  Input,
  Message,
  Segment
} from 'semantic-ui-react';

import '../css/Login.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import navigationManager, { VIEW_SELECTION } from '../managers/NavigationManager';

import DynamicSatelliteService from '../services/DynamicSatelliteService';

export default @inject(
  'dynamicSatelliteManager', 'userManager')
@observer
class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      fail: false,
      invalidEmail: false,
      loaded: false,
      success: false
    };
    this.Logo = SatCoreComponent('Logo');
    this.SatCoreLoader = SatCoreComponent('SatCoreLoader');
  }

  async componentDidMount() {
    this.setState({ loaded: false });

    const { dynamicSatelliteManager } = this.props;

    navigationManager.setView(VIEW_SELECTION.LOGIN);

    if (dynamicSatelliteManager.isDynamicSatellite && !Auth.publisherSatelliteCode) {
      await DynamicSatelliteService.fetchDynamicSatelliteByDomain();
      setTimeout(() => {
        this.setState({ loaded: true });
      }, 500);
    } else {
      this.setState({ loaded: true });
    }
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState(
      {
        [e.target.name]: e.target.value
      }
    );
  }

  handleSendEmail = async (event) => {
    const { email } = this.state;
    const { userManager } = this.props;
    event.preventDefault();
    this.setState({ fail: false, success: false });

    if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
      this.setState({ invalidEmail: true });
      return;
    }

    const result = await userManager.sendResetEmail(email);
    if (result) {
      this.setState({ fail: false, success: true });
    } else {
      this.setState({ fail: true, success: false });
    }
  }

  resetState = () => {
    this.setState({
      fail: false,
      invalidEmail: false,
      success: false
    });
  }

  render() {
    if (Auth.loggedIn()) {
      return <Redirect to='/' />;
    }
    const { Logo, SatCoreLoader } = this;
    const { loaded, success, fail, invalidEmail } = this.state;

    return loaded ? (
      <Grid className='fullHeight login-body forgot-password-body' textAlign='center' verticalAlign='middle'>
        <Grid.Column>
          <Form>
            <Header as='h2' attached='top' block className='forgot-password-form-header'>
              <Logo />
              <h2 className='header-text'>Reset Password</h2>
            </Header>
            <div className='login-divider' />
            <Segment attached className='element-body-login element-body-login-forgot-password'>
              <Form.Field>
                <label>Email</label>
                <Input
                  name='email'
                  onChange={this.handleChange}
                  onFocus={this.resetState}
                  placeholder='name@email.com'
                  type='email' />
              </Form.Field>
              <Form.Field>
                <Button className='reset' onClick={this.handleSendEmail} primary>
                  Send Reset Email
                </Button>
              </Form.Field>
            </Segment>
          </Form>
          {(success)
            ? (
              <Message positive>
                <Message.Header>Check your email</Message.Header>
                <p>
                  If a profile is associated with that email, you will receive a link to reset your password.
                </p>
              </Message>
            ) : null}
          {(fail) ? (
            <Message negative>
              <Message.Header>Something went wrong</Message.Header>
              <p>
                Resetting your password has failed.  Please check your email and try again.
              </p>
            </Message>
          ) : null}
          {(invalidEmail) ? (
            <Message negative>
              <Message.Header>Something went wrong</Message.Header>
              <p>
                Please enter a valid email format. (name@example.com)
              </p>
            </Message>
          ) : null}
        </Grid.Column>
      </Grid>
    ) : <SatCoreLoader />;
  }
}

SatCoreRegister('ForgotPassword', ForgotPassword);
